// extracted by mini-css-extract-plugin
export default {"container":"Trend_container__8mEp6","header":"Trend_header__V31MU","arabicText":"Trend_arabicText__RVsRT","normalText":"Trend_normalText__Rhlan"};